import { FC } from "react";

import { Box, Stack } from "@mui/material";

import { useTranslate } from "@/common/hooks/useTranslate";
import { DashboardButton } from "@/dashboard-design-system/DashboardButton";
import { DashboardIconBlock } from "@/dashboard-design-system/DashboardIconBlock/DashboardIconBlock";
import { DashboardTypography } from "@/dashboard-design-system/Typography";
import { Add, Sparks } from "@/icons/outlined";

interface AttendeeSuggestionRowProps {
  label: string;
  onDismiss: () => void;
  onAdd: () => void;
}

export const AttendeeSuggestionRow: FC<AttendeeSuggestionRowProps> = ({ label, onDismiss, onAdd }) => {
  const { t } = useTranslate();

  return (
    <Stack
      direction="row"
      alignItems="center"
      spacing={1.5}
      data-test="v4-guest-suggestion-row"
      sx={(theme) => ({
        backgroundColor: theme.palette.surface.neutral.white,
        border: `1px dashed ${theme.palette.border.neutral.moderate}`,
        borderRadius: 1,
        px: 2,
        py: 1,
      })}
    >
      <DashboardIconBlock vibe="brand" size="medium" sx={{ flexShrink: 0 }}>
        <Sparks />
      </DashboardIconBlock>

      <DashboardTypography variant="subtitle2" vibe="text-brand-intense" sx={{ flex: 1, minWidth: 0 }} noWrap>
        <Box component="span" sx={{ fontStyle: "italic", fontWeight: "fontWeightRegular" }}>
          {t("dashboard", "stepQuestionsV4.suggestion.suggestedPrefix")}
        </Box>{" "}
        {label}
      </DashboardTypography>

      <Stack direction="row" alignItems="center" spacing={1}>
        <DashboardButton
          variant="text"
          vibe="brand"
          size="small"
          onClick={onDismiss}
          data-test="v4-guest-suggestion-dismiss"
        >
          {t("dashboard", "stepQuestionsV4.suggestion.dismiss")}
        </DashboardButton>
        <DashboardButton
          variant="tonal"
          vibe="brand"
          size="small"
          startIcon={<Add />}
          onClick={onAdd}
          data-test="v4-guest-suggestion-add"
        >
          {t("dashboard", "stepQuestionsV4.suggestion.add")}
        </DashboardButton>
      </Stack>
    </Stack>
  );
};
